module.exports = __webpack_public_path__ + "static/media/Onboarding1.3df8ef92.png";